import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbActionsModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSidebarModule,
  NbUserModule,
  NbContextMenuModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbPopoverModule,
NbDialogModule,
NbCardModule,
  NbThemeModule,
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
 import { NbSecurityModule } from '@nebular/security';
//import {NumberSpacedPipe} from '../shared/classes/number-spaced.pipe'
import {
  FooterComponent,
  HeaderComponent,
  //SearchInputComponent,
  //TinyMCEComponent,
} from './components';
import {
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
} from './pipes';
import {
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  EmptyLayoutComponent,
  EmptyFullLayoutComponent	
} from './layouts';

import { DEFAULT_THEME } from './styles/theme.default';
//import { COSMIC_THEME } from './styles/theme.cosmic';
//import { CORPORATE_THEME } from './styles/theme.corporate';
import { DARK_THEME } from './styles/theme.dark';

import { RetentionBadgeModule } from '../retention-badge/retention-badge.module';
import { StorageBadgeModule } from '../storage-badge/storage-badge.module';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbPopoverModule,
  NbIconModule,
  NbEvaIconsModule,
	NbCardModule,
NbDialogModule
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  //SearchInputComponent,
  //TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
	EmptyLayoutComponent,
EmptyFullLayoutComponent
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
//NumberSpacedPipe
];


@NgModule({
  imports: [CommonModule, RetentionBadgeModule, StorageBadgeModule, ...NB_MODULES],
  exports: [CommonModule, RetentionBadgeModule, StorageBadgeModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {



  static getTheme(){
 

    return localStorage.getItem('theme') || 'default'
    
  }

  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: ThemeModule.getTheme(),
          },
          // COSMIC_THEME, CORPORATE_THEME,
          [ DEFAULT_THEME, DARK_THEME ],
        ).providers,
      ],
    };
  }
}
